export { MedicamentsFavoritesService } from 'src/app/medicaments-favorites/services/httpRequests/medicaments-favorites.service';